import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import moment from 'moment';
import { truncate } from 'lodash';
import NotificationService from '../../../core/services/NotificationService';

const CheckoutLinkList = (props) => {
  const handleCopyLink = (token) => {
    navigator.clipboard.writeText(`${window.location.origin.replace('admin', 'checkout')}?token=${token}`);
    NotificationService.addNotification('Link copied to clipboard', 'success');
  };

  return (
    <Table
      fetching={props.fetching}
      columns={[
        {
          label: 'Customer',
          path: 'customer',
        },
        {
          label: 'Segment',
          path: 'segment.name',
        },
        {
          label: 'Hubspot Deal',
          path: 'hubspotDealId',
        },
        {
          label: 'New Dashboard',
          path: 'allowNewDashboard',
          render: (cell) => (cell ? 'Yes, client wants the new Dashboard' : 'No, client wants the old Admin'),
        },
        {
          label: 'Created by',
          path: 'createdBy.name',
        },
        {
          label: 'Created At',
          path: 'createdAt',
          render: (cell) => moment(cell).format('DD/MM/YYYY'),
        },
        {
          label: 'Agreed At',
          path: 'agreedAt',
          render: (cell) => cell && moment(cell).format('DD/MM/YYYY'),
        },
        {
          label: 'Paid At',
          path: 'paidAt',
          render: (cell) => cell && moment(cell).format('DD/MM/YYYY'),
        },
        {
          label: 'Link',
          path: 'id',
          render: (token) => (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${window.location.origin.replace('admin', 'checkout')}?token=${token}`}
            >
              {truncate(`${window.location.origin.replace('admin', 'checkout')}?token=${token}`, { length: 100 })}
            </a>
          ),
        },
        {
          label: 'Actions',
          path: 'action',
          width: '90px',
          render: (cell, row) => (
            <>
              <Button icon="copy" onClick={() => handleCopyLink(row.id)} />{' '}
              <Button icon="delete" onClick={() => props.onDelete(row)} />
            </>
          ),
        },
      ]}
      rows={props.links}
      pagination={props.pagination}
      onChange={props.onChange}
    />
  );
};

CheckoutLinkList.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      customer: PropTypes.string.isRequired,
    })
  ).isRequired,
  fetching: PropTypes.bool.isRequired,
  pagination: PropTypes.shape({
    total: PropTypes.number,
    current: PropTypes.number,
    pageSize: PropTypes.number,
  }),
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

export default CheckoutLinkList;
